import AxiosJsonpAdapter from './axios-jsonp-adapter'
import Axios from 'axios'

// add jsonp adapter
Axios.interceptors.request.use(function (config) {
  if (config.method.toLocaleLowerCase() === 'jsonp') {
    config.method = 'GET'
    config.adapter = AxiosJsonpAdapter
  }
  return config
})

// add jsonp method
Axios.jsonp = function (url, options = {}) {
  return Axios.request({
    ...options,
    method: 'jsonp',
    url: url
  })
}

// default response pip
function defaultResponsePip (res) {
  return res
}

// create api helper func
export const createApi = function (pip, apis) {
  const responseHandle = typeof pip === 'function' ? pip : defaultResponsePip
  const instances = apis || pip
  const dit = {}
  for (let instance in instances) {
    dit[instance] = function () {
      return new Promise((resolve, reject) => {
        const result = instances[instance].apply(null, arguments)
        // 如果直接返回了请求对象
        if (result instanceof Promise) {
          result.then(res => {
            try {
              resolve(responseHandle(res))
            } catch(err) {
              reject(err)
            }
          })
        } else if (typeof result === 'object') {
          Axios.request(result).then(res => {
            try {
              resolve(responseHandle(res))
            } catch(err) {
              reject(err)
            }
          }).catch(err => {
            reject(err)
          })
        } else {
          throw new Error('Instance must be return an Object or request Promise.')
        }
      })
    }
  }
  return dit
}

Axios.createApi = createApi

// e.g: jsonp
// Axios.request({
//   method: 'jsonp',
//   jsonp: 'callback',
//   url: 'https://api.github.com',
//   params: {
//     query: 123
//   },
//   // jsonp: 'callback',
//   // baseURL: 'https://cnodejs.org',
// }).then(res => {
//   console.log('res:', res)
// })

export default Axios
